<template>
  <button @click="cancelTransfers" :aria-label="$t('sidebar.cancelTransfers')" :title="$t('sidebar.cancelTransfers')" class="action" id="cancel-transfers-button">
    <x-icon size="1.5x" class="custom-class"></x-icon>
    <span v-if="isMobile">{{ $t('sidebar.cancel') }}</span>
    <span v-else>{{ $t('sidebar.cancelTransfers') }}</span>
  </button>
</template>

<script>

import {mapState} from 'vuex';
import { XIcon } from 'vue-feather-icons';

export default {
  name: 'cancel-transfers-button',
  components: {
    XIcon
  },
  computed: {
    ...mapState(['req', 'selected']),
    isMobile () {
      return window.innerWidth <= 768;
    },
  },
  methods: {
    cancelTransfers: async function () {
        if (!this.selected.length) {
          await ibb.cancelTransfersByType(this.req.transferType);
        }
        else {
          let promises = [];
          for (let index of this.selected) {
            promises.push(ibb.cancelTransferByTag(this.req.items[index].tag));
          }

          await Promise.all(promises);
        }

        this.$store.commit('setReload', true);
    }
  }
};
</script>
